import React from "react";
import { Box, Typography } from "@mui/material";

interface InfoChipProps {
  icon: React.ReactElement;
  label: string | number;
}

export const InfoChip: React.FC<InfoChipProps> = ({ icon, label }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
    {React.cloneElement(icon, {})}
    <Typography variant="body2" sx={{ color: "#614438", fontSize: "0.8rem" }}>
      {label}
    </Typography>
  </Box>
);

export default InfoChip;
